import { useState, useRef, useEffect } from "react";
import { Search, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { MODULES } from "@/lib/modules";
import { useI18n } from "@/context/I18nContext";

export default function SearchBar({ onPick }) {
  const { t } = useI18n();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const timer = useRef();

  useEffect(() => {
    clearTimeout(timer.current);
    if (q.trim().length < 2) { setResults([]); return; }
    setBusy(true);
    timer.current = setTimeout(async () => {
      try { const { data } = await api.get(`/search?q=${encodeURIComponent(q)}`); setResults(data); setOpen(true); }
      finally { setBusy(false); }
    }, 300);
  }, [q]);

  return (
    <div className="relative w-full max-w-md">
      <div className="relative">
        {busy ? <Loader2 size={16} className="absolute left-3 top-2.5 text-cyan-400 animate-spin" />
          : <Search size={16} className="absolute left-3 top-2.5 text-slate-400" />}
        <input value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => results.length && setOpen(true)}
          data-testid="global-search-input"
          placeholder={t("Szukaj: klient, kabel, mufa, ONU, adres…")}
          className="w-full bg-slate-800/95 backdrop-blur border border-slate-700 rounded-md pl-9 pr-3 py-2 text-sm outline-none focus:ring-2 focus:ring-cyan-500" />
      </div>
      {open && results.length > 0 && (
        <div className="absolute top-full mt-1 w-full bg-slate-800 border border-slate-700 rounded-md max-h-80 overflow-y-auto shadow-2xl z-[900]" data-testid="search-results">
          {results.map((r) => {
            const Icon = MODULES[r.type]?.icon || Search;
            return (
              <button key={`${r.type}-${r.id}`} onClick={() => { onPick(r); setOpen(false); }}
                className="w-full text-left px-3 py-2 hover:bg-slate-700 flex items-center gap-2.5 border-b border-slate-800/60">
                <Icon size={15} className="text-cyan-400 shrink-0" />
                <div className="min-w-0">
                  <div className="text-sm truncate">{r.title}</div>
                  <div className="text-xs text-slate-400 truncate">{r.label}{r.subtitle ? ` · ${r.subtitle}` : ""}</div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
